/* The Risen Cross: reveal on scroll, gallery dots, sticky bar, straight-to-checkout buy */
(function () {
  "use strict";

  // Scroll reveal (IntersectionObserver, no scroll listeners)
  var reveals = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("is-in"); });
  }

  // Gallery: swipe, arrows and thumbnails all move the same track and stay in sync
  var track = document.querySelector("[data-gallery]");
  var thumbs = document.querySelectorAll("[data-thumbs] button");
  if (track && track.children.length > 1) {
    var count = track.children.length;
    var current = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var go = function (i) { track.scrollTo({ left: ((i + count) % count) * track.clientWidth, behavior: "smooth" }); };
    var sync = function () {
      var i = current();
      thumbs.forEach(function (t, n) { t.setAttribute("aria-current", n === i ? "true" : "false"); });
    };
    track.addEventListener("scroll", function () { window.requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener("click", function () { go(n); }); });
    var prev = document.querySelector("[data-gallery-prev]");
    var next = document.querySelector("[data-gallery-next]");
    if (prev) { prev.addEventListener("click", function () { go(current() - 1); }); }
    if (next) { next.addEventListener("click", function () { go(current() + 1); }); }
  }

  // What you get: hover or tap a number on the photo; the card in the photo explains that part
  document.querySelectorAll("[data-parts]").forEach(function (box) {
    var data = box.querySelector("[data-parts-data]");
    if (!data) { return; }
    var rows = data.content.querySelectorAll("p");
    var title = box.querySelector("[data-part-title]");
    var text = box.querySelector("[data-part-text]");
    var pins = box.querySelectorAll(".pin");
    var show = function (pin) {
      var row = rows[Number(pin.getAttribute("data-part"))];
      if (!row) { return; }
      pins.forEach(function (p) { p.classList.toggle("is-active", p === pin); });
      title.textContent = row.getAttribute("data-t");
      text.textContent = row.textContent;
    };
    pins.forEach(function (pin) {
      pin.addEventListener("mouseenter", function () { show(pin); });
      pin.addEventListener("focus", function () { show(pin); });
      pin.addEventListener("click", function () { show(pin); });
    });
  });

  // Videos: play only while on screen; with reduced motion, stay paused on the poster
  var vids = document.querySelectorAll("video[autoplay]");
  var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  vids.forEach(function (v) { v.muted = true; if (still) { v.removeAttribute("autoplay"); v.pause(); } });
  if (!still && "IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) { p.catch(function () {}); } } else { e.target.pause(); }
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { vio.observe(v); });
  }

  // Delivery window: today + 8 to 14 business days (the store's real US shipping time)
  var eta = document.querySelector("[data-eta]");
  if (eta) {
    var addBiz = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) { n--; } } return x; };
    var fmt = function (d) { return d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" }); };
    var now = new Date();
    var a = addBiz(now, Number(eta.getAttribute("data-min")) || 8), b = addBiz(now, Number(eta.getAttribute("data-max")) || 14);
    eta.innerHTML = "Free US delivery: get it between <b>" + fmt(a) + "</b> and <b>" + fmt(b) + "</b>.";
  }

  // Sticky buy bar: shows once the main Buy button has scrolled out of view
  var bar = document.querySelector("[data-stickybar]");
  var mainBtn = document.querySelector("[data-buy-button]");
  if (bar && mainBtn && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle("is-on", off);
      bar.setAttribute("aria-hidden", off ? "false" : "true");
    }).observe(mainBtn);
  }

  // Buy now: replace the cart with the chosen quantity, then go straight to checkout.
  // Without JS the form still posts to /cart/add with return_to=/checkout.
  var heroForm = document.querySelector(".buy[data-buy-form]");
  if (heroForm) {
    var totalEl = heroForm.querySelector("[data-buy-total]");
    heroForm.querySelectorAll('[name="quantity"]').forEach(function (r) {
      r.addEventListener("change", function () { if (totalEl && r.checked) { totalEl.textContent = r.getAttribute("data-total"); } });
    });
  }
  var giftNote = document.querySelector("[data-bible-gift]");
  if (heroForm && giftNote) {
    var syncGift = function () { var r = heroForm.querySelector('[name="quantity"]:checked'); giftNote.hidden = !(r && r.value === "2"); };
    heroForm.querySelectorAll('[name="quantity"]').forEach(function (r) { r.addEventListener("change", syncGift); });
    syncGift();
  }
  document.querySelectorAll("[data-buy-form]").forEach(function (form) {
  if (window.fetch) {
    form.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var btn = form.querySelector("[data-buy-button]");
      btn.setAttribute("aria-busy", "true");
      var id = form.querySelector('[name="id"]').value;
      var qEl = form.querySelector('[name="quantity"]:checked') || form.querySelector('[name="quantity"]');
      var qty = parseInt(qEl.value, 10) || 1;
      var items = [{ id: Number(id), quantity: qty }];
      var bible = form.querySelector("[data-bible]");
      if (bible) {
        var wantBible = bible.getAttribute("data-mode") === "gift" ? qty === 2 : !!form.querySelector("[data-bible-check]:checked");
        if (wantBible) { items.push({ id: Number(bible.getAttribute("data-variant")), quantity: 1 }); }
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(root + "cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } })
        .then(function () {
          return fetch(root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { if (!r.ok) { throw new Error("add failed"); } window.location.href = root + "checkout"; })
        .catch(function () { btn.removeAttribute("aria-busy"); form.submit(); });
    });
  }
  });
})();
